































import Vue from "vue";
import Component from "vue-class-component";
import { maps } from "@/store";
import { MutationTypes } from "@/store/mutations-types";

interface ILayer {
  name: string;
  key: string;
}

@Component
export default class MapMenu extends Vue {
  //Data
  layers: ILayer[] = [
    {
      name: "OpenStreetMap",
      key: "osm",
    },
    {
      name: "Carta naútica",
      key: "nautical",
    },
    {
      name: "Dark Map",
      key: "dark",
    },
    {
      name: "Mapa topográfico",
      key: "topo",
    },
  ];

  //computed
  get layerSelector() {
    return maps.getters.baseLayer;
  }
  set layerSelector(value) {
    maps.commit(MutationTypes.SELECT_BASELAYER, value);
  }
}
